module.exports = __webpack_public_path__ + "img/infoBtn.7afb8dd1.svg";